import {
    AMPLITUDE_OR_SCALE_CHANGE,
    DELETE_IMAGE_SUCCESS,
    DELETE_MULTIPLE_IMAGES_SUCCESS,
    FETCH_IMAGES_AND_USER_SUCCESS,
    IMAGE_FETCH_SUCCESS,
} from '../actions/ImageActions';
import keyBy from 'lodash/keyBy';
import omit from 'lodash/omit';
import get from 'lodash/get';
import filter from 'lodash/filter';
import {IMAGE_VIEWER_SET_PREFERRED_SUCCESS} from '../actions/PresetActions';

function imagesSingleUser(state = {}, action) {
    switch (action.type) {
        case FETCH_IMAGES_AND_USER_SUCCESS: {
            const successfulImages = filter(action.images, img => img.status === 'SUCCESS');
            const map = keyBy(successfulImages, 'id');
            return {...state, ...map};
        }
        case IMAGE_FETCH_SUCCESS: {
            const {imageInfo} = action;
            return {...state, [imageInfo.id]: omit(imageInfo, 'edits')};
        }
        case IMAGE_VIEWER_SET_PREFERRED_SUCCESS: {
            const {id, amplitude, spread} = action;
            return {...state, [id]: {...state[id], preferredAmplitude: amplitude, preferredSpread: spread}};
        }
        case DELETE_IMAGE_SUCCESS: {
            const {id} = action;
            return omit(state, id);
        }
        case DELETE_MULTIPLE_IMAGES_SUCCESS: {
            const {ids} = action;
            return omit(state, ids);
        }
        case AMPLITUDE_OR_SCALE_CHANGE: {
            const {id, amplitude, spread} = action;
            return {...state, [id]: {...state[id], amplitude, spread}};
        }
        default:
            break;
    }
    return state;
}

export function images(state = {}, action) {
    const userId = action.userId || get(action, 'user.id', get(action, 'image.userId', get(action, 'imageInfo.userId')));
    if (userId) {
        const oldImages = state[userId] || {};
        const newImages = imagesSingleUser(oldImages, action);
        if (oldImages !== newImages) {
            return {...state, [userId]: newImages};
        }
    }
    return state;
}




// WEBPACK FOOTER //
// ./src/reducers/images.js